"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Module that provides utility functions to allow adding and removing playlist items
 *
 * With JW, mutating the playlist stops playback, loads the video and starts again.
 * To provide a better UX, we store a Queue of mutations and execute them when a new video
 * is loading. This is best for the user experience.
 *
 * @module PlayablesUtils
 */

var REMOVE = 'REMOVE';
var INSERT = 'INSERT';

/**
 * Returns the playables with the proper shape from the rawPlayer.
 * This function is needed as we let JW maintain the playlist, but we need
 * to maintain our API shape with the mutations in effect.
 *
 * @param {JW Instace} rawPlayer
 * @param {{type: string, playable: ?Playable, index: ?number}[]} Array of mutations
 *
 * @return {Playable[]}
 */
function getPlayables(rawPlayer, _playableMutations) {
  if (!rawPlayer || !rawPlayer.getPlaylist) {
    return [];
  }
  var rawPlayables = rawPlayer.getPlaylist();
  if (!rawPlayables) {
    return [];
  }
  var playables = rawPlayables.map(function (playlistItem) {
    return {
      ads: playlistItem.adschedule,
      src: playlistItem.file,
      startTime: playlistItem.startTime,
      endTime: playlistItem.endTime
    };
  });
  _playableMutations.forEach(function (_ref) {
    var type = _ref.type,
      playable = _ref.playable,
      index = _ref.index;
    if (type === REMOVE) {
      playables.splice(index, 1);
    } else {
      playables.splice(index, 0, playable);
    }
  });
  return playables;
}

/**
 * JW only has one mechanism for changing playlist, player.load(playlist).
 * When this happens, it stops playback and rebuilds the entire playlist.
 *
 * To give a better UX and not stop the video, we are queuing any inserts/removes
 * and this function gets called at the end of the playlistItem. A time in which
 * the screen should already be black for a moment.
 */
function load() {
  var actuallyNeedsToCallLoad = !!this._playableMutations.length;
  var playables = this.playables;
  // reset state
  this._temporaryPlayingIndex = undefined;
  this._playableMutations = [];
  if (actuallyNeedsToCallLoad) {
    var playingIndex = this.playingIndex;
    this.rawPlayer.load(playables.map(function (p) {
      return _objectSpread(_objectSpread({}, p), {}, {
        file: p.src
      });
    }));
    this.playingIndex = playingIndex;
  }
}

/**
 * Add a playable to the player's playables at a given index
 * Shape of playlist item: { src, (startTime, endTime) }
 *
 * @param {Playable}
 * @param {number}
 *
 * @return {Playable[]}
 */
function insert(playable, index) {
  this._playableMutations.push({
    type: INSERT,
    playable: playable,
    index: index
  });
}

/**
 * Push a playable into the end of the playables list.
 *
 * @param {Playable}
 *
 * @return {Playable[]}
 */
function push(playable) {
  return insert.call(this, playable, this.playables.length);
}

/**
 * Removes a playlist item from the player's playlist
 * Returns a boolean representing whether the removal was successful
 *
 * @param {number} index to remove from
 *
 * @return {Playable[]}
 */
function remove(index) {
  this._playableMutations.push({
    type: REMOVE,
    index: index
  });
  if (index === this.playingIndex) {
    load.call(this);
  } else if (index < this.playingIndex) {
    this._temporaryPlayingIndex = this.playingIndex - 1;
  }
}
var _default = exports["default"] = {
  getPlayables: getPlayables,
  insert: insert,
  load: load,
  push: push,
  remove: remove
};